import { useThemeContext } from '@huggg/react-components';
import classnames from 'classnames';
import { HugggLife } from 'components';
import { Link as UiLink } from 'components/ui';
// import goldblumVideo from 'assets/video/expired_goldblum.mp4';
// import tomVideo from 'assets/video/redeemed_tom.mp4';
// import stashedVideo from 'assets/video/stashed_baby.mp4';
import dictionary from 'config/dictionary';
import externalLinks from 'config/externalLinks';
import { format as dateFormat, parseISO } from 'date-fns';
import useDictionary from 'hooks/useDictionary';
import PropTypes from 'prop-types';
import React from 'react';
import { interpolate, interpolateMany } from 'utilities/interpolate';
import Error from './Error';
import styles from './custom.module.scss';

export const CustomError = (props) => {
  const { operator, name: theme } = useThemeContext();
  const {
    bodyText,
    isBlueHuggg,
    showSupportContact = true,
    title,
    videoUrl,
  } = props;

  const shouldShowHugggLife = theme === 'default' && !isBlueHuggg;

  return (
    <>
      <Error
        className={classnames('container', styles.container)}
        render={() => (
          <>
            <header className={styles.header}>
              <h1 className={styles.title}>{title}</h1>
            </header>

            {videoUrl && (
              <div className={styles.videoContainer}>
                <video
                  className="video"
                  muted
                  loop
                  autoPlay
                  playsInline
                  src={videoUrl}
                  type="video/mp4"
                />
              </div>
            )}

            {bodyText && <div className={styles.bodyText}>{bodyText}</div>}

            {showSupportContact && operator.showHugggSupportLinks && (
              <div className={styles.links}>
                {interpolate(
                  dictionary.error.links,
                  '[email_support_link]',
                  <UiLink.HugggEmailSupport
                    to={externalLinks.email.support.url}
                  />,
                )}
              </div>
            )}
          </>
        )}
      />

      {shouldShowHugggLife && <HugggLife />}
    </>
  );
};

CustomError.propTypes = {
  huggg: PropTypes.object.isRequired,
  isBlueHuggg: PropTypes.bool,
  showSupportContact: PropTypes.bool,
  title: PropTypes.any.isRequired,
  videoUrl: PropTypes.string,
  bodyText: PropTypes.element,
};

export const ExpiredError = (props) => {
  const dictionary = useDictionary();
  const {
    huggg: { expiry, expiry_date, isSuperhuggg },
    voucherExpiryDate,
  } = props;

  const title = interpolateMany(dictionary.error.expired.title, [
    ['[br]', <br key={null} />],
    [':emoji_lightning:', <>⚡️</>],
    ['[huggg_type]', <>{isSuperhuggg ? 'superhuggg' : 'huggg'}</>],
  ]);

  const expiryDate =
    voucherExpiryDate ?? expiry ?? expiry_date ?? new Date().toISOString();

  const bodyText = interpolate(
    dictionary.error.expired.bodyCopy,
    '[expiration_date]',
    <>{dateFormat(parseISO(expiryDate), 'dd/MM/yyyy')}</>,
  );

  return (
    <CustomError
      {...props}
      title={title}
      bodyText={isSuperhuggg ? null : bodyText}
    />
  );
};

ExpiredError.propTypes = {
  huggg: PropTypes.object.isRequired,
  voucherExpiryDate: PropTypes.string,
};

export const RedeemedError = (props) => {
  const dictionary = useDictionary();
  return <CustomError {...props} title={dictionary.error.redeemed.title} />;
};

export const NotOwnerError = (props) => {
  const dictionary = useDictionary();
  return <CustomError {...props} title={dictionary.error.notOwner.title} />;
};

export const AllClaimedError = (props) => {
  const dictionary = useDictionary();
  return <CustomError {...props} title={dictionary.error.allClaimed.title} />;
};

export const CancelledError = (props) => {
  const dictionary = useDictionary();
  return <CustomError {...props} title={dictionary.error.cancelled.title} />;
};
